import { render, staticRenderFns } from "./RootContabilitaEstraiView.vue?vue&type=template&id=74014821&"
import script from "./RootContabilitaEstraiView.vue?vue&type=script&lang=ts&"
export * from "./RootContabilitaEstraiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports